export const tagColors = [
  '#E08633',
  '#E7659D',
  '#6CBE49',
  '#8959D5',
  '#5985D5',
  '#59CFD5',
  '#B9D54A',
  '#E35656',
  '#DFE798',
  '#D6BAE8',
  '#BED0FA',
  '#F6B8D2',
  '#E8D8CC',
  '#C7A49F',
  '#BCC1CD',
  '#FAB5AC',
];

export enum TagDialogState {
  Open = 'open',
  Closed = 'closed',
}

export const NEW_TAG_KEY = 'new';
